<div class="close-Area">
    <mat-icon class="pull-right" mat-dialog-close>close</mat-icon>
</div>

<!-- <div class="success">
    <div class="text-center cpopup">
        <div>
           
            <p class="mt-30 f-28 fw-900 addlh">You have requested to reset your password.</p>
            <p class="mt-30 f-26 addlh">A unique reset password link is sent to your registered email address. </p>
        </div>
    </div>
   
</div> -->
<div class="text-center cpopup">
    <img src="../../../../assets/images/icons/Congratulations.png" width="100" height="100" />
    <p class="mt-30 f-24 addlh">You have requested to reset your password.</p>
    <div class="mt-20 f-20">A unique reset password link is sent to your registered email address.</div>
</div>